import { ResponseMethod, ErrorCode } from 'Modules'

export enum ERROR_CODE {
	MULTIPLE_RESULT = 'multiple_results',
	NOT_FOUND = 'not_found',
	BG_REQUEST_PREFIX = 'bg_request_',
	FORBIDDEN = 'forbidden',
	IS_REQUIRED = 'is_required',
	INVALID = 'invalid',
	EQUAL_TO_PARTNER_INN = 'equal_to_partner_inn',
	ERROR = 'error',
}
export enum AST_ERROR_CODE {
	REJECT_DESCRIPTION = 'reject_description',
	REQUEST_FAILED = 'request_failed',
}
export const AST_ERROR_KEYS = [AST_ERROR_CODE.REJECT_DESCRIPTION, AST_ERROR_CODE.REQUEST_FAILED]

export const DEFAULT_ERROR_PARAMS = {
	config: {
		method: ResponseMethod.PATCH,
	},
	status: ErrorCode.e422,
}
